<template>
  <l-map
    ref="map"
    :crs="crs"
    :center="center"
    :maxBounds="maxBounds"
    :minZoom="minZoom"
    :maxZoom="maxZoom"
    :zoom="currentZoom"
    @leaflet:load="mapLoaded"
    class="l-map"
  >
    <l-control :position="'bottomright'" class="custom-control-watermark">
      <!-- Vue2Leaflet Watermark Control -->
    </l-control>
    <l-layer-group>
      <l-image-overlay
        v-for="(marker, index) in markerListGetter"
        :key="index"
        :url="marker.url"
        :bounds="marker.bounds"
        interactive
        :bubblingMouseEvents="false"
        @mouseover="hoverMarker(marker)"
      ></l-image-overlay>
      <l-image-overlay
        v-if="showScaleMarker"
        :url="currentMarker.url"
        :bounds="currentMarker.bounds"
        interactive
        :bubblingMouseEvents="false"
        @mouseleave="leaveMarker"
        @click="onMarkerClick(currentMarker)"
      >
      </l-image-overlay>
    </l-layer-group>
  </l-map>
</template>

<script>
import * as L from 'leaflet';
import _ from 'underscore';
import {
  LMap,
  LMarker,
  LImageOverlay,
  LLayerGroup,
  LControl,
} from 'vue2-leaflet'; //leaflet组件

// const imgWidth = 2328,
// imgHeight = 2064;
const imgWidth = 3680,
  imgHeight = 2720;
const maxZoom = 4;
const iconSize = 200;
const crs = L.CRS.Simple;

const southWest = crs.pointToLatLng(L.point(0, imgHeight), maxZoom - 1),
  northEast = crs.pointToLatLng(L.point(imgWidth, 0), maxZoom - 1);
const imgBounds = new L.LatLngBounds(southWest, northEast);
export default {
  components: {
    LMap,
    LControl,
    LLayerGroup,
    LImageOverlay,
  },
  props: {
    markerList: {
      type: Array,
    },
  },
  data() {
    return {
      map: null,
      crs: crs,
      currentZoom: 1,
      minZoom: 1,
      maxZoom: maxZoom,
      maxBounds: imgBounds,
      center: imgBounds.getCenter(),
      showScaleMarker: false,
      currentMarker: {},
    };
  },
  computed: {
    guidelist() {
      return this.$store.state.map.guidelist;
    },
    filtGuidelist() {
      let arr = [];
      for (let item of this.guidelist) {
        let result = {
          id: item.id,
          point: [Number(item.point_x), Number(item.point_y)],
        };
        arr.push(result);
      }
      return arr;
    },

    markerListGetter() {
      // [{
      //   icon: require('@/assets/images/block.png'),
      //   id: 'test1',
      //   point: [485, 130],
      // }],

      // TODO：测试数据后续请修改为空数组
      return this.filtGuidelist.map((m) => ({
        ...m,
        url: require('@/assets/images/block.png'),
        bounds: L.latLngBounds(
          crs.pointToLatLng(
            L.point(m.point[0] - iconSize / 2, m.point[1] + iconSize / 2),
            maxZoom - 1,
          ),
          crs.pointToLatLng(
            L.point(m.point[0] + iconSize / 2, m.point[1] - iconSize / 2),
            maxZoom - 1,
          ),
        ),
        // icon: L.icon({
        //   // iconUrl: m.icon,
        //   iconUrl: require('@/assets/images/block.png'),
        //   iconSize: [35, 40],
        //   iconAnchor: [15, 20],
        // }),
        // point: crs.pointToLatLng(L.point(m.point), maxZoom - 1),
      }));
    },
  },

  methods: {
    mapLoaded() {
      this.$emit('mapLoaded', this.$refs.map.mapObject);
      this.map = this.$refs.map.mapObject;
      const imageUrl = require('@/assets/images/map99.jpg');
      L.imageOverlay(imageUrl, imgBounds).addTo(this.map);
    },
    onMarkerClick(marker) {
      let currentMarker = _.find(this.guidelist, (cur) => {
        return cur.id == marker.id;
      });
      this.$emit('update', { showDialog: true, currentMarker: currentMarker });
    },
    hoverMarker(marker) {
      let current = _.find(this.guidelist, (cur) => {
        return cur.id == marker.id;
      });
      this.showScaleMarker = true;
      this.currentMarker = Object.assign({}, marker, {
        url: current.scenic_icon,
        bounds: L.latLngBounds(
          crs.pointToLatLng(
            L.point(
              Number(current.point_x) - iconSize,
              Number(current.point_y) + iconSize,
            ),
            maxZoom - 1,
          ),
          crs.pointToLatLng(
            L.point(
              Number(current.point_x) + iconSize,
              Number(current.point_y) - iconSize,
            ),
            maxZoom - 1,
          ),
        ),
      });
      //   let point = [current.point_x, current.point_y];
      //   this.currentMarker.id = marker.id;
      //   this.currentMarker.icon = L.icon({
      //     iconUrl: current.scenic_icon,
      //     iconSize: [80, 80],
      //     iconAnchor: [40, 40],
      //   });
      //   this.currentMarker.point = crs.pointToLatLng(L.point(point), maxZoom - 1);
    },
    leaveMarker() {
      this.showScaleMarker = false;
      this.currentMarker = {};
    },
  },
};
</script>

<style>
.iclient-leaflet-logo.leaflet-control,
.leaflet-control-attribution,
.leaflet-control-zoom.leaflet-bar {
  display: none;
}
.l-map {
  background-color: white;
}
.leaflet-image-layer {
  background: url(../../assets/images/icon-sound.png) no-repeat right top;
  background-size: 20px 20px;
}
</style>
